import { ClampToEdgeWrapping, MirroredRepeatWrapping, RepeatWrapping } from 'three';

export const wrappingValues = {
    RepeatWrapping,
    ClampToEdgeWrapping,
    MirroredRepeatWrapping,
};

export const wrappingNames: { [v: number]: Wrapping } = {};
Object.keys(wrappingValues).forEach((k: Wrapping) =>
{
    wrappingNames[wrappingValues[k]] = k;
});

export type Wrapping = keyof typeof wrappingValues;
